<template>
  <div>
    <div v-show="!isLoading">
      <VideoPool :folders="folders" :actions="actions"></VideoPool>
    </div>
    <Loading v-show="isLoading"></Loading>
  </div>
</template>
<style>
</style>
<script>
import { EvaIcon } from 'vue-eva-icons'
import VideoPool from '@/components/Video/VideoPool.vue'
import Loading from '@/components/Utility/Loading.vue'
export default {
  components: {
    Loading,
    VideoPool,
    [EvaIcon.name]: EvaIcon
  },
  data () {
    return {
      folders: [],
      actions: [{
      //   fn: this.addMission,
      //   name: '增加任務'
      // },
      // {
        fn: this.goToVideoDetail,
        name: '觀看影片'
      }],
      isLoading: true
    }
  },
  methods: {
    fetch_all_folders: async function () {
      let result = await this.$store.dispatch('request', {
        // route: 'videos/2'
        route: 'resources'
      })
      // console.log(result.sub_folders)
      console.log(result)
      this.folders = result
      if (this.$store.getters.isStudent) {
        this.folders = this.folders.filter(file => file.info.id !== 7)
      }
      this.isLoading = false
    },
    goToVideoDetail: function (file) {
      console.log(this.$router)
      this.$router.push({
        name: 'Video',
        query: {
          subject: file.parent_id,
          file: file.info.id
        }
      })
      console.log(file)
    }
    // addMission: function (file) {

    // }
  },
  created () {
    this.fetch_all_folders()
  }
}
</script>
